import { platformHandler } from '../../../PlatformHandler'
import { requestPostSail } from '../../../../utils/requester'

let fscg = {};

var osConnector;
var isWin = true;

//Almacena un array con todas las notas de cada diapositiva cuando se inicia el slideShow
//var slidesNotes = null;
var slidesImages = null;

var infoActivities = null;

//Se pone en true cuando ya esta conectado con PowerPoint
var powerPointConnected = false;

//Se pone en true cuando se inicia el modo Slideshow
var inSlideShowMode = false;

var widhtImage = 0;
var heightImage = 0;

//El numero de la diapositiva actual
var currentSlideIndex = -1;
var currentIdActivity = "";

//Para pasar de puntos a pixels, basandose en un DPI de 72 y un PPI de 96
var pointsToPixel = 96/72;

//url donde se guarda la imagen descargada de cada actividad de toglea (el preview)
//var imagePathToglea = "";

var pptName = "";
var previewsPath = "C:/Users/PC01/AppData/Local/Temp/slidePreviews";
//var codeSession = "";
var resX, resY, resW, resH;

var request = window.require('request');
var fs = window.require('fs');
var util = window.require('util');
var stream = window.require('stream')
var md5File = window.require('md5-file');
var userFB;

export default function TogleaSlideConnectorGeneral() {
	var os = window.require('os');
	if( os.platform() == "darwin"){
		isWin = false;
	}

	if(isWin) {
		let FlipwitSlideConnectorWindows = require('./windows/FlipwitSlideConnectorWindows.js');
		osConnector =  FlipwitSlideConnectorWindows.default(fscg);
	}
	else {
		pointsToPixel = 1;
		let FlipwitSlideConnectorMac = require('./mac/FlipwitSlideConnectorMac.js');
		osConnector = FlipwitSlideConnectorMac.default(fscg);
	}

	this.currentSlideExport = 2;
	this.enableExport = false;

	var ipc = window.require('electron').ipcRenderer;
	ipc.on('flipwitPlugin', fscg.onMessagePlugin);

	/*if(isWin) {
		var monitor = require('active-window');
		monitor.getActiveWindow(fscg.onCallbackMonitor, -1, 1);
	}*/

	return fscg;
}

fscg.onCallbackMonitor= function(windowActive){
	//console.log(windowActive)
}

fscg.onMessagePlugin = function(event, message) {
	console.log("onMessagePlugin:", message);
	switch( message.cmd ){
		case "initInfo": fscg.sendInitInfo();
			break;

		case "sizeImage": fscg.sendImageSize();
			break;

		//MODIFIED
		case "listenActMsgs": platformHandler.setListenerActMsgs( fscg.OnActMsgs, platformHandler.getCurrentIdAct(), null );
			break;

		case "listenUsersConnections": platformHandler.setListenerUsersMsgs( fscg.OnUsers );
			break;

		default: console.error('command not supported ', message)
	}
}

fscg.sendInitInfo = function( data ) {
	var tempData = platformHandler.getObjectInfoActivity(platformHandler.getCurrentIdAct());
	if (!tempData) {
		return false;
	}
	var temp = {
		cmd: "initInfoCB",
		source:"flipwit",
		title: tempData.title,
		info: tempData.info,
		count: platformHandler.getStoreData().usersCount,
		session: platformHandler.getUrlForUser(),
	};
	fscg.sendToTogleaWindow( temp );
}

//Para mandarle información a la vista de videobeam
fscg.sendToTogleaWindow = function( data ) {
	const remote = window.require('electron').remote;
	remote.app.sendMessage( data );
}

fscg.init = function( timeScriptWSH ) {
	console.log('inicializa el general: ')
	this.timeScriptWSH = timeScriptWSH;
	osConnector.init();

	try {
		this.hideTogleaWindow();
		//fscg.testFunction();
	}
	catch(err) {
	   console.log(err);
	}
}

fscg.testFunction = function() {
	//Datos prueba windows
	var data = {"command":"imageInSlide","name":"Picture 2","x":"28,1852","y":"19,00315","width":"665,8652","height":"489,3784","wslide":"720,125","hslide":"540","resX":"1440","resY":"0","resW":"1440","resH":"810"}

	//Datos prueba MAC
	/*
	var data = {"command":"imageInSlide","name":"Picture 2","x":"28.185195922852","y":"19.003149032593","width":"665.865173339844","height":"489.37841796875","wslide":"720.125","hslide":"540","resX":"0","resY":"0","resW":"1280","resH":"800"}
	console.log("data es:")
	console.log(data);//*/

	this.setTogleaSlide(this.fixDecimal(data.name), this.fixDecimal(data.x), this.fixDecimal(data.y), this.fixDecimal(data.width),
      this.fixDecimal(data.height), this.fixDecimal(data.wslide), this.fixDecimal(data.hslide), this.fixDecimal(data.resX),
      this.fixDecimal(data.resY), this.fixDecimal(data.resW), this.fixDecimal(data.resH));
}

fscg.fixDecimal = function(str) {
  return str.replace(",",".");
}

fscg.setPowerPointConnected = function(val) {
	powerPointConnected = val;
	console.log('esta conectado: ' + val )
	//Si se perdio la conexion se esconde la ventana de videobeam
	if(val==false) {
		//this.hideTogleaWindow();
	}

	platformHandler.setPowerPointConnected( val );
}

fscg.isConnected = function() {
	return powerPointConnected;
}

fscg.setPreviewsPath = function( path ){
	if( isWin ){
		previewsPath = path;
	}
	else{
		previewsPath = path.replace(new RegExp(":", 'g'), "/");;

		if( !path.startsWith("/")){
		    previewsPath = previewsPath.substring( previewsPath.indexOf("/") );
		}
	}
	
  console.log("Leer previews de path " + previewsPath)

}

//las notas las recibe cuando empieza el modo presentacion F5
fscg.setSlidesNotes = function( notes ){
	if( platformHandler.isAuditoriumMode() ){
		platformHandler.auditoriumAction( "slidesNotes", notes );
		return;
	}

	if(! platformHandler.canReceivePptsCommands() ){
		return;
	}
	console.log("setea las notas");
	platformHandler.setSlidesNotes( notes );
	platformHandler.setStateInitPresentation(1, 1);
}

fscg.verifyPreviews = function() {
	if( platformHandler.isAuditoriumMode() ){
		platformHandler.auditoriumAction( "verifyPreviews" );
		return;
	}

	if(! platformHandler.canReceivePptsCommands() ){
		return;
	}
	var scope = this;

	this.currentSlideExport = 3;//al inicio en el wsh esta que se exportan las primeras 2 y la actual
	this.enableExport = true;

	var amountSlidesFirstBlock = 2;
	var md5generated = false;
	var firstPartProcessed = false;

	var payloadMd5Data = {};
	var allPreviews = [];
	var allSlidesToRefresh = [];
	var allSlidesData = [];
	var currentPreviewToSend = -1;

	var lastPartSent = false;

	let sendNextPreview = function() {
		if ( platformHandler.inSlideShowMode ){
			if(currentPreviewToSend<allSlidesToRefresh.length-1) {
				currentPreviewToSend++;
				console.log('siguiente ' + currentPreviewToSend);
				sendPreview();
			}
			else {
				firstPartProcessed = true;
				if(isWin) {
					var payload = {
						pptName:pptName,
						userId: platformHandler.getUser(),
					};
					requestPostSail( process.env.REACT_APP_URL_SERVICES + 'slides/setCompleted', payload, (data) => { console.log('setCompleted', data)} );
					platformHandler.setStateInitPresentation(2,1);
				}
				else{
					if(md5generated && !lastPartSent) {
						console.log('Caso 1 - Envia datos a previews con ' + payloadMd5Data.firstData);
					  	lastPartSent = true;
					  	requestPostSail(  process.env.REACT_APP_URL_SERVICES + 'slides/checkPreviews', payloadMd5Data, callbackCheckPreviews.bind(this) );
					}
					else{
						platformHandler.setStateInitPresentation(2,1);
					}
				}
			}
		}
	}

	let sendPreview = function() {
		if ( !platformHandler.inSlideShowMode ){
			return;
		}
		console.log('El index1 que llego es ' + currentPreviewToSend);
		console.log('El index que llego es ' + allSlidesToRefresh[currentPreviewToSend] + " " + allPreviews[allSlidesToRefresh[currentPreviewToSend]-1].sent);
		//console.log(allSlidesToRefresh);
		//console.log('Corresponde a ' + JSON.stringify(allPreviews[allSlidesToRefresh[currentPreviewToSend]-1]));
		//console.log('Actualizar a slide con id ' + allPreviews[allSlidesToRefresh[currentPreviewToSend]-1].id + ' nombre: ' + allPreviews[allSlidesToRefresh[currentPreviewToSend]-1].path);

		//Si ya se envio la informacion de ese slide se ignora ya que por concurrencia se debe hacer,
		//es decir, ya se envio pero no se ha recibido respuesta aun.
		if(allPreviews[allSlidesToRefresh[currentPreviewToSend]-1].sent){
			sendNextPreview();
			return;
		}

		allPreviews[allSlidesToRefresh[currentPreviewToSend]-1].sent = true;

		// read binary data
		var bitmap = null;
		if(isWin) {
			let pathImage = previewsPath + "/" + allSlidesToRefresh[currentPreviewToSend] + ".jpg";
			if ( !fs.existsSync(pathImage)) {
				allPreviews[allSlidesToRefresh[currentPreviewToSend]-1].sent = false;
			    setTimeout( sendPreview, 300);
			    return;
			}

			var md5FileHash
			try{
				md5FileHash = md5File.sync( pathImage );
			}
			catch( e ){
				console.log('error en md5 ' + e );
				allPreviews[allSlidesToRefresh[currentPreviewToSend]-1].sent = false;
				setTimeout( sendPreview, 300);
				return;
			}

			var md5Server = allSlidesData[allSlidesToRefresh[currentPreviewToSend]-1].md5;
			console.log('compara ' + md5Server + " " + md5FileHash)
			if( md5Server == md5FileHash ){
				sendNextPreview();
				return;
			}

			bitmap = fs.readFileSync( pathImage );
		}
		else{
			bitmap = fs.readFileSync(allPreviews[allSlidesToRefresh[currentPreviewToSend]-1].path);
		}
		var newFile = new Blob([bitmap]);
		platformHandler.getFirebaseConnector().uploadImage(platformHandler.getUser(),pptName,allPreviews[allSlidesToRefresh[currentPreviewToSend]-1].id,newFile
			, function(userId,pptName,slideIndex,downloadURL) {

				var payloadUrl = {
					pptName,
					userId,
					slideIndex,
					data: downloadURL,
					md5: isWin ? md5FileHash : allPreviews[allSlidesToRefresh[currentPreviewToSend]-1].md5,
					last: !(currentPreviewToSend<allSlidesToRefresh.length-1),
				};

				requestPostSail( process.env.REACT_APP_URL_SERVICES + 'slides/uploadSlideUrl', payloadUrl, function( data ){
					platformHandler.modifySlideData(data.slideIndex,data.url);
					console.log('Retorno uploadSlide ' + data.slideIndex + ' y asigno ' + data.url)
					sendNextPreview();
				});
			}
		);
	}

	let callbackCheckPreviews = function( data ){
		var payloadBase64Data = {};

		console.log('Llega un ' + JSON.stringify(data))

		if( data.success ){

			//La respuesta contiene los slides que se deben cambiar unicamente
			allSlidesToRefresh = allSlidesToRefresh.concat(data.resp);
			allSlidesData = data.allSlidesData;
			platformHandler.setSlidesData(data.allSlidesData);

			sendNextPreview();
		}
	}

	let callbackReadDir = function( err, items ){
		if(items[0] == '.DS_Store')
			items.splice(0,1);

		if(isWin) {
			try{
				items.sort(function(a, b) {
					return fs.statSync(previewsPath + "/" + a).mtime.getTime() -
		                      fs.statSync(previewsPath + "/" + b).mtime.getTime();
		       	});
			}
			catch( e ){
				console.log('ERROR order');
				setTimeout( function(){
			        callbackReadDir(err, items);
			      }, 300);
				return;
			}

		}
		else{
			items.sort();
		}

		//se obtiene el tamaño de la diapositiva 1 para manejo de dibujoy puntero
		scope.getDimensionSlide(previewsPath + "/" + items[0]);

		console.log("ORDENADOS", items)
		console.log("is isLAN " + platformHandler.isLAN)
		if( platformHandler.isLAN ){
			var dataPreviews = [];
			for (var i=0; i<items.length; i++) {
	    		var previewInfo = {
	    			url: previewsPath + "/" + items[i],
	    			id: i+1,
    			}
	    		dataPreviews.push(previewInfo);
	    	}

			platformHandler.setSlidesData(dataPreviews);
			return;
		}

		if( isWin ){
			payloadMd5Data.data = new Array(platformHandler.getTotalSlides());
		}
		else{
			payloadMd5Data.data = [];
		}
		payloadMd5Data.pptName = pptName;
		payloadMd5Data.userId = platformHandler.getUser();

		/* Por optimizacion primero se envian los datos de unos slides segun lo especificado en la variable
			amountSlidesFirstBlock, de esta manera por ejemplo si el ppt tiene 200 diapositivas no toca esperar a
			tener los md5 de las 200 para iniciar la presentación, entonces lo que se hace es que apenas haya una cantidad
			definida, por ejemplo 2, se envian para verificar si se deben o no cambiar previews y se inicia la presentacion
			mientras se sigue haciendo lo de los otros 198. esta variable firstData indica que lo que se va a enviar es el primer
			pedazo, pues en el segundo envio realmente se envia todo todo, incluyendo las 2 del inicio, esto ya que se pueden haber
			borrado diapositivas y eso debe quedar en el servidor.
		 */
		payloadMd5Data.firstData = true;

		if( isWin ){
			for (var i=0; i<payloadMd5Data.data.length; i++) {

				var md5FileHash = "";
				var fileName = "";
				var path = "";
				if( items[i] ){
					try{
						md5FileHash = md5File.sync(previewsPath + "/" + items[i]);
						path = previewsPath + "/" + items[i];
						fileName = items[i];
		    		}
		    		catch( e ){
		    			console.log('ERROR md5');
		    			setTimeout( function(){
					        callbackReadDir(err, items);
					      }, 300);
		    			return;
		    		}
				}

		    	var previewInfo = {
	    			path,
	    			id: i+1,
	    			fileName,
	    			md5: md5FileHash,
	    			sent: false
	    		}

		    	allPreviews.push(previewInfo);

		    	//if(i==0) md5FileHash = "" + Math.random();

		    	//Se coloca la url vacia porque igual el sails no sobreescribe directamente sino que
		    	//procesa pero si es la primera vez si guarda el vacio
		    	payloadMd5Data.data[i] = {	idSlide:i+1,
		    						md5:md5FileHash,
		    						note:platformHandler.slidesNotes[i],
		    						url:""
		    						};
		    }

		    console.log('Parte 1 - Envia datos a previews con ' + payloadMd5Data.firstData + ' y ' + payloadMd5Data.data.length);
		    requestPostSail(  process.env.REACT_APP_URL_SERVICES + 'slides/checkPreviews1By1', payloadMd5Data, callbackCheckPreviews.bind(this) );
		}
		else{
			for (var i=0; i<items.length; i++) {
				var md5FileHash = md5File.sync(previewsPath + "/" + items[i]);

		    	var previewInfo = {
	    			path: previewsPath + "/" + items[i],
	    			id: i+1,
	    			fileName: items[i],
	    			md5: md5FileHash,
	    			sent: false
	    		}

		    	allPreviews.push(previewInfo);

		    	//if(i==0) md5FileHash = "" + Math.random();

		    	//Se coloca la url vacia porque igual el sails no sobreescribe directamente sino que
		    	//procesa pero si es la primera vez si guarda el vacio
		    	payloadMd5Data.data.push({	idSlide:i+1,
		    						md5:md5FileHash,
		    						note:platformHandler.slidesNotes[i],
		    						url:""
		    						});


		    	console.log(items[i] + " -MD5- " + md5FileHash);
		    	//|| (i == items.length - 1 && items.length < amountSlidesFirstBlock)
		    	if(i==amountSlidesFirstBlock-1 || (i == items.length - 1 && items.length < amountSlidesFirstBlock)) {
		    		console.log('Parte 1 - Envia datos a previews con ' + payloadMd5Data.firstData + ' y ' + payloadMd5Data.data.length);
		    		requestPostSail(  process.env.REACT_APP_URL_SERVICES + 'slides/checkPreviews', payloadMd5Data, callbackCheckPreviews.bind(this) );
		    		payloadMd5Data.firstData = false;
		    	}
		    }

		    md5generated = true;

		    //Si los primeros slides ya fueron procesados entonces envia la info de los slides restantes
			if(firstPartProcessed && !lastPartSent) {
				console.log('Caso 2 - Envia datos a previews con ' + payloadMd5Data.firstData + ' y ' + payloadMd5Data.data.length);
				lastPartSent = true;
				requestPostSail(  process.env.REACT_APP_URL_SERVICES + 'slides/checkPreviews', payloadMd5Data, callbackCheckPreviews.bind(this) );
			}
		}


	}


	console.log("Leer previews de path " + previewsPath)
	fs.readdir(previewsPath, callbackReadDir);
}

/*fscg.setSessionCode = function(codeSessionFromSails) {
	codeSession = codeSessionFromSails;
}*/

fscg.setSlidesImages = function( images ){
	console.log("las imagenes");
	console.log( images );
	slidesImages = images;
}

fscg.setTogleaSlideInfo = function( currentSlideIndex, urlActivity ){
	var data = slidesImages[currentSlideIndex-1];
    console.log(data)
    fscg.setTogleaSlide( data.name, data.x, data.y, data.width, data.height, data.wslide, data.hslide, data.resX, data.resY, data.resW, data.resH, urlActivity );
    osConnector.activatePP();
}

fscg.setPPTName = function( name ){
	if( platformHandler.isAuditoriumMode() ){
		platformHandler.auditoriumAction( "pptName", name );
		return;
	}

	if(! platformHandler.canReceivePptsCommands() ){
		return;
	}

	console.log('NAME: ' + name)
	if( name != pptName ){
		platformHandler.setPPTName(name);
		pptName = name;
		//codeSession = "";
	}

	console.log('pptName: ' + pptName)
}

fscg.slideShowEnds = function () {
	if( platformHandler.isAuditoriumMode() ){
		platformHandler.auditoriumAction( "slideShowEnds" );
		return;
	}

	if( ! platformHandler.canReceivePptsCommands() ){
		return;
	}

	platformHandler.slideShowEnds();
	fscg.hideTogleaWindow();
}

//Cuando estoy en la ultima diapositiva de powerPoint y doy Next va a una diapositiva negra
//que indica que se acabo la presentacion, eso es notificado acá para que se agregue uno a
//el currentSlideIndex colocandolo en un valor mayor a la cantidad de diapositivas
//con la intencion de que si en esa pantalla dan PREV se vuelva a procesar la informacion de
//la ultima diapositiva
fscg.slideShowDone = function() {
	if( platformHandler.isAuditoriumMode() ){
		platformHandler.auditoriumAction( "slideShowDone" );
		return;
	}

	if( ! platformHandler.canReceivePptsCommands() ){
		return;
	}

	platformHandler.slideShowDone();
}

fscg.setElectronSession = function() {
	if( ! platformHandler.canReceivePptsCommands() ){
		return;
	}

	platformHandler.setElectronSession();
}

//Cambia el index logico de la presentacion (diapositiva actual)
//y si refreshSlide es true entonces refresca la informacion del electron
fscg.setSlidePosition = function( position, refreshSlide ){
	if( platformHandler.isAuditoriumMode() ){
		platformHandler.auditoriumAction( "slidePosition", {position, refreshSlide} );
		return;
	}

	if( ! platformHandler.canReceivePptsCommands() ){
		return;
	}

	if( position <= 0 ){
		if( platformHandler.getSlideIndex() > 0 ){
			return;
		}
		position = 1;
	}
  	platformHandler.setSlidePosition(position, refreshSlide)
}

fscg.downloadFile = function(file_url , idImage, pptName, comment, webView ){//ADDED
    // TODO Save variable to know progress
    var targetPath = osConnector.getTempPath() + "/" + idImage + ".jpg";
    var received_bytes = 0;
    var total_bytes = 0;

    const stream = fs.createWriteStream(targetPath);
	const req = request.get(file_url);
	req.pipe(stream);

	var tempThis = this;

	stream.on('finish', function () {
		console.log("File succesfully downloaded in " + targetPath + " < " + idImage + " >");
        tempThis.insertSlide( targetPath, idImage, pptName, comment, webView );
	});

    /*
    var req = request({
        method: 'GET',
        uri: file_url
    });

    var out = fs.createWriteStream(targetPath);
    req.pipe(out);


    req.on('response', function ( data ) {
        // Change the total bytes value to get progress later.
        total_bytes = parseInt(data.headers['content-length' ]);
        console.log('total: '+  total_bytes)
    });

    req.on('data', function(chunk) {
        // Update the received bytes
        received_bytes += chunk.length;

        var percentage = (received_bytes * 100) / total_bytes;
    	console.log(percentage + "% | ");
    });

    req.on('end', function() {
        console.log("File succesfully downloaded in " + targetPath + " < " + idImage + " >");
        tempThis.insertSlide( targetPath, idImage, pptName, comment, webView );
    });

    */
}

fscg.insertSlide = function( path, idImage, pptName, comment, webView ){
	/*TODO cdaqavar sizeOf = require('image-size');
	var dimensions = sizeOf(path);
	console.log(dimensions.width, dimensions.height);
	console.log("ahora si inserte: " + path  );*/
	osConnector.insertSlide( path, idImage, 800, 600, pptName, comment );

	if( webView != null ){
		var resp = {
	      source:"flipwit",
	        cmd: "insertActCB",
	        success: true,
	        id: idImage
	    };

	    webView.sendMessage( JSON.stringify(resp) );
	}
}

fscg.insertActivity = function( id, urlImg, pptName, comment, webView ){
	this.downloadFile(urlImg,  id, pptName, comment, webView);
}


fscg.executeCommand = function(val){
	console.log('Enviar comando ', val)
	if( val.command === "InteractionFeature") {
		switch( val.interactionType ) {
	      case "Next":  osConnector.goNextSlide();
	      				this.hideTogleaWindow( true );
	      				break;
	      case "Prev": 	osConnector.goPrevSlide();
	      				this.hideTogleaWindow( true );
	      				break;
	      case "Init": 	osConnector.startSlideshow(val.pptName);
	      				platformHandler.setStateInitPresentation(0, 1);
	      				break;
	      case "Finish": osConnector.finishSlideshow(); break;
	    }
	}
}

fscg.setTogleaSlide = function( name, x, y, width, height, wslide, hslide, resX, resY, resW, resH, urlActivity ){

	x = this.fixDecimal(x)
	y = this.fixDecimal(y)
	width = this.fixDecimal(width)
	height = this.fixDecimal(height)
	wslide = this.fixDecimal(wslide)
	hslide = this.fixDecimal(hslide)
	resX = this.fixDecimal(resX)
	resY = this.fixDecimal(resY)
	resW = this.fixDecimal(resW)
	resH = this.fixDecimal(resH)

	//params togleaimage       0   0 960    540     960     540     1024.5 0    600   450
	console.log('params',name, x, y, width, height, wslide, hslide, resX, resY, resW, resH)

	const remote = window.require('electron').remote;
	//const remote = require('electron').remote;
	//const BrowserWindow = remote.BrowserWindow;

	//w=1366 h: 768
	var mainScreenSize = remote.app.getMainScreenSize(0);
	console.log('mainScreenSize',mainScreenSize);
	//800 450
	var newDimension = this.getScaleDimension( wslide, hslide, resW, resH );

	console.log( newDimension.width, newDimension.height);

	var offsetX = Number(resX)>0?mainScreenSize.width:0;
	var offsetY = Number(resY)>0?mainScreenSize.height:0;

	//1366 -(offsets)- 0
	console.log(offsetX + " -(offsets)- " + offsetY);

	if( offsetX > 0 ){
		mainScreenSize = remote.app.getMainScreenSize(1);
	}

	x = (x * newDimension.width) / wslide;
	y = (y * newDimension.height) / hslide;

	width = (width * newDimension.width) / wslide;
	height = (height * newDimension.height) / hslide;

	console.log('mainScreenSize 2', mainScreenSize);
	//width: 1280, height: 800

	var xTemp = Math.floor((mainScreenSize.width - newDimension.width) / 2) + offsetX;
	var yTemp = Math.floor((mainScreenSize.height - newDimension.height) / 2) + offsetY;

	var isTransparent = true;

	if(!isWin) {
		isTransparent = false;
		xTemp = Math.floor((resW - newDimension.width) / 2) + offsetX;
	}

	//xTemp = Math.floor((resW - newDimension.width) / 2) + offsetX;
	//yTemp = Math.floor((resH - newDimension.width) / 2) + offsetX;

	//var objWindow = {x: Math.floor(xTemp+x), y: Math.floor(yTemp+y), width: Math.ceil(newDimension.width), height: Math.ceil(newDimension.height), hasShadow:false, transparent:true,resizable: false, alwaysOnTop: true,frame: false }
	var objWindow = {x: Math.floor(xTemp+x), y: Math.floor(yTemp+y), width: Math.ceil(width) + 1 , height: Math.ceil(height) + 1, hasShadow:false, transparent:isTransparent,resizable: false, alwaysOnTop: true,frame: false, focusable: false, skipTaskbar: true }
	console.log("objWindow",objWindow)
	//height: 451 width: 801 x: 1649 y: 159.

	fscg.TogleaWindowPresent = true;
	remote.app.createWindowToglea(objWindow);
	remote.app.deactivateTogleaMouseEvents();
	//remote.app.loadTogleaURL("https://toglea-9fec0.firebaseapp.com/question");

	if( urlActivity == 'OVER'){
		remote.app.loadTogleaURL( urlActivity, true );
	}
	else{
		remote.app.loadTogleaURL( urlActivity + "/viewer/index.html", true );
		//remote.app.loadTogleaURL( "http://localhost:3001/", true );
	}
}

fscg.hideTogleaWindow = function( setTransparent = false ) {
	fscg.TogleaWindowPresent = false;
	const remote = window.require('electron').remote;
	remote.app.hideTogleaWindow( setTransparent );
}

fscg.fixDecimal = function(str) {
	if ( (typeof str) == "string" ){
		return str.replace(",",".");
	}

	return str;
}

fscg.getScaleDimension = function( wslide, hslide, resW, resH ) {

	console.log('argumentos')
	console.log(arguments)
	//720, 540, 1920, 1080

	console.log('para ' + resW + " y " + wslide + " es " + (resW/wslide))
	//para 1920 y 720 es 2.6666666666666665

	let wFactor = resW/wslide;
	let hFactor = resH/hslide;

	let newWidth = resW;
	let newHeight = resH;

	if(hFactor<wFactor) {
		newWidth = wslide*hFactor;
	}
	else {
		newHeight = hslide*wFactor;
	}

	return {width: newWidth*pointsToPixel, height: newHeight*pointsToPixel};
}

// function to encode file data to base64 encoded string
fscg.base64_encode = function(filePath) {
	// read binary data
    var bitmap = fs.readFileSync(filePath);
    // convert binary data to base64 encoded string
    return new Buffer(bitmap).toString('base64');
}


fscg.OnUsers = function( users ) {
	console.log('llegan users ')
	console.log( users )

	var temp = {
		source:"flipwit",
		cmd: "listenUsersConnectionsCB",
		users: users
	};
	fscg.sendToTogleaWindow( temp );
}

fscg.OnActMsgs = function( msgs ) {
	console.log('llegan msgs ', msgs)

	var dataMsgs = msgs;
	if( !platformHandler.isLAN ){
		dataMsgs = msgs.val();
	}

	var temp = {
		source:"flipwit",
		cmd: "listenActMsgsCB",
		info: dataMsgs
	};
	fscg.sendToTogleaWindow( temp );
}

fscg.pptsOpen = function( ppts ) {

	console.log('name PPT', this.originalPPTName )
	if( platformHandler.isAuditoriumMode() && this.startedFromAuditorium){
		if( ppts.indexOf(this.originalPPTName) === -1 ){
			this.checkIfClosePresentation();
		}
	}

	platformHandler.pptsOpen( ppts );
}

fscg.getPptsOpen = function(){
	osConnector.getPptsOpen();
}

fscg.isDataFromSelected = function(){

}

fscg.onCloseElectron = function(){
	//if( !isWin ){
		osConnector.setImagesVisible();
	//}
}

fscg.setDrawingCanvas= function( data ){
	console.log('the data before', data.shapes)
	var temp = {
		cmd: "drawing",
		source:"flipwit",
		info: { shapes: Object.values( data.shapes ), colors: data.colors}
	};

	//console.trace();
	console.log('senddd new tals ', temp.info)
	fscg.sendToTogleaWindow( temp );
}

fscg.setPointer= function( visible, x, y ){
	var temp = {
		cmd: "pointer",
		source:"flipwit",
		info: {visible:visible, x:x, y:y}
	};
	fscg.sendToTogleaWindow( temp );
}

fscg.showDrawingCanvas = function( ){
	fscg.setTogleaSlide( "", 0, 0, widhtImage, heightImage, widhtImage, heightImage, resX, resY, resW, resH, "OVER" );
    osConnector.activatePP();
}

fscg.setResolutionData = function( resXTemp, resYTemp, resWTemp, resHTemp ){
	resX = resXTemp;
	resY = resYTemp;
	resW = resWTemp;
	resH = resHTemp;
}

fscg.sendImageSize = function( data ) {
	var temp = {
		cmd: "imageSizeCB",
		source:"flipwit",
		widhtImage: widhtImage,
		heightImage: heightImage,
	};
	fscg.sendToTogleaWindow( temp );

	//this.setDrawingCanvas(platformHandler.getCurrentSlideDrawing());
	platformHandler.updateElectronDrawing();
}

fscg.errorData = function(  ) {
	platformHandler.errorConnector();
}

fscg.uploadSlides = function( namePPT, cbState, startedFromAuditorium ) {
	
	if( startedFromAuditorium && platformHandler.inSlideShowMode && namePPT != this.originalPPTName ){
		this.closeAuditoriumSession();
	}
  	this.cbStateUpload = cbState;
  	this.startedFromAuditorium = startedFromAuditorium;
  	console.log('seteado', this.startedFromAuditorium, startedFromAuditorium)
  	allPreviewsExport = [];
	allSlidesToRefreshExport = [];
	allSlidesDataExport = [];
	platformHandler.setStateInitPresentation( isWin ? 0 : 4, -1);
	osConnector.exportSlides( namePPT, startedFromAuditorium );
}

fscg.fillEmptyImages = function( payloadMd5Data ){
	for ( var i = payloadMd5Data.data.length; i < platformHandler.getTotalSlides(); i ++) {
		//Se coloca la url vacia porque igual el sails no sobreescribe directamente sino que
    	//procesa pero si es la primera vez si guarda el vacio
    	payloadMd5Data.data.push({	idSlide:i+1,
    						md5:"",
    						note:platformHandler.slidesNotes[i],
    						url:""
    						});

    }
}

fscg.setSuffixName = function( ) {
	suffixName = " "+ (new Date()).toLocaleString();
}

fscg.uploadFirstSlides = function( err, items  ) {
  console.log('read first ', err, items, this)
  allPreviewsExport = [];
  allSlidesToRefreshExport = [];
  allSlidesDataExport = [];

  this.setSuffixName();
  this.sentAll = false;
  this.firstSlides = true;
  this.allSlidesExported = false;
  this.sortFiles( items );
  console.log('item sorted', items)
  this.getDimensionSlide( previewsPath + "/" + items[0] );
  let payloadMd5Data = this.getPayloadExport();

  let isSharing = platformHandler.auditoriumAction( "isSharing" );

  const config = {
	shareFinish : isSharing, 
	nick : isSharing
  };
  platformHandler.setConfigSlides( config, false );
  payloadMd5Data.config = config;
  
  currentPreviewToSendExport = -1;
  this.setMD5Items( items, payloadMd5Data );
  if( payloadMd5Data.data.length < platformHandler.getTotalSlides() ){
  	this.fillEmptyImages( payloadMd5Data );
  }

  this.firstPartProcessed = false;
  console.log('pide checkPreviews ', payloadMd5Data)
  requestPostSail( process.env.REACT_APP_URL_SERVICES + 'slides/checkPreviews', payloadMd5Data, this.callbackFirstSlides.bind(this) );
}

fscg.uploadRestSlides = function( err, items  ) {
  if( this.sentAll ){
  	return;
  }

  allPreviewsExport = [];
  allSlidesToRefreshExport = [];
  allSlidesDataExport = [];

  this.sentAll = true;
  console.log('read rest ', err, items, this)
  this.sortFiles( items );
  console.log('item sorted', items)
  this.getDimensionSlide( previewsPath + "/" + items[0] );
  let payloadMd5Data = this.getPayloadExport( true );
  currentPreviewToSendExport = -1;
  this.setMD5Items( items, payloadMd5Data );
  console.log('pide checkPreviews ', payloadMd5Data)
  this.firstSlides = false;
  requestPostSail( process.env.REACT_APP_URL_SERVICES + 'slides/checkPreviews', payloadMd5Data, this.callbackRestSlides.bind(this) );
}

fscg.callbackRestSlides = function( data ){
  if( data.success ){
  	//La respuesta contiene los slides que se deben cambiar unicamente
  	allSlidesToRefreshExport = allSlidesToRefreshExport.concat(data.resp);
  	allSlidesDataExport = data.allSlidesData;

    platformHandler.setSlidesData(data.allSlidesData);
    console.log('call send next preview')
    this.sendNextPreviewAuditorium();    
  }
}

fscg.getPPTName = function( ){
	this.originalPPTName = platformHandler.getPPTName();
	return platformHandler.getPPTName() + ( ( platformHandler.isAuditoriumMode() && this.startedFromAuditorium) ? suffixName : "");
}

fscg.callbackFirstSlides = function( data ){
  if( data.success ){
  	//La respuesta contiene los slides que se deben cambiar unicamente
  	allSlidesToRefreshExport = allSlidesToRefreshExport.concat(data.resp);
  	allSlidesDataExport = data.allSlidesData;

  	console.log('callbackFirstSlides', data)

    platformHandler.setSlidesData(data.allSlidesData);
    platformHandler.cloudPresentationID = data.idCloud;
    platformHandler.presentationStarted( this.getPPTName(), true, platformHandler.cloudPresentationID );
    this.sendNextPreviewAuditorium();
  }
}

fscg.sendNextPreviewAuditorium = function() {
	console.log('sendNextPreviewAuditorium', currentPreviewToSendExport, allSlidesToRefreshExport, allPreviewsExport )
	if(currentPreviewToSendExport<allSlidesToRefreshExport.length - 1) {
		console.log('IS FIRST Slides', this.firstSlides, currentPreviewToSendExport)
		if( this.firstSlides ){
			if ( currentPreviewToSendExport <= 0 ){
				currentPreviewToSendExport++;
				console.log('siguiente ' + currentPreviewToSendExport, allSlidesToRefreshExport);
				this.sendPreview();
			}
			else{
				this.firstPartProcessed = true;
				if(this.allSlidesExported) {
					fs.readdir(previewsPath, this.uploadRestSlides.bind(this));
				}	
			}			
		}
		else{
			currentPreviewToSendExport++;
			console.log('siguiente ' + currentPreviewToSendExport, allSlidesToRefreshExport);
			this.sendPreview();
		}
	}
	else {
		if( this.firstPartProcessed ){

		}
		/*else{
			this.firstPartProcessed = true;
			if(this.allSlidesExported) {
				this.uploadRestSlides();
			}			
		}*/

		/*var payload = {
			pptName:platformHandler.getPPTName(),
			userId: platformHandler.getUser(),
		};
		requestPostSail( process.env.REACT_APP_URL_SERVICES + 'slides/setCompleted', payload, (data) => { 
			isUploadingImages = false;
			if ( data.success ){
				platformHandler.setStateInitPresentation(2,1);
			} 
			else{
				this.cbStateUpload( { error:true} ,isWin);
			}
		});*/		
	}
}



fscg.onSlidesExported = function( resp ) {
	console.log('onSlidesExported ', resp)

	if( resp.cmd == "CONT_EXPORT"){
		console.log('isAuditoriumMode', platformHandler.isAuditoriumMode(), this.startedFromAuditorium, this)
		if( platformHandler.isAuditoriumMode() && this.startedFromAuditorium){
			if( resp.response.exporting ){
				if(  resp.response.last <= 2 ){
					 fs.readdir(previewsPath, this.uploadFirstSlides.bind(this));
				}
			}
			else{
				this.allSlidesExported = true;
				if(this.firstPartProcessed) {
					fs.readdir(previewsPath, this.uploadRestSlides.bind(this));
				}			
			}
		}
		else{
			if( resp.response.exporting ){
				platformHandler.setStateInitPresentation(0, resp.response.last);
			}
			else{
				if( isWin ){
			        platformHandler.setStateInitPresentation(1, 1);
			        fs.readdir(previewsPath, this.readDirUploadCB.bind(this));
			    }
			    else{
			        this.cbStateUpload( { state: 0, path: previewsPath + 'FlipwitPDF.pdf'} ,isWin);
			    }
			}
		}
			
	}
	else{
		prefixToExport = resp.response.prefixToExport;
		this.setPreviewsPath( resp.response.previewsPath);
		platformHandler.slidesNotes = resp.response.notes;
		platformHandler.setTotalSlides( resp.response.notes.length );
	}
}

var allPreviewsExport = [];
var allSlidesToRefreshExport = [];
var allSlidesDataExport = [];
var currentPreviewToSendExport = -1;
var isUploadingImages = false;
var suffixName = "";
var prefixToExport = '';

fscg.readDirUploadCB = function( err, items ) {
	console.log('read dir ' + isUploadingImages, err, items, this)
  if( isUploadingImages ){
  	return;
  }

  isUploadingImages = true;

  items = items.filter( item => item.startsWith(prefixToExport )); 
  console.log('items', prefixToExport, items)

  this.sortFiles( items );
  console.log('item sorted', items)
  this.getDimensionSlide( previewsPath + "/" + items[0] );
  let payloadMd5Data = this.getPayloadExport();
  currentPreviewToSendExport = -1;

  this.setMD5Items( items, payloadMd5Data );

  console.log('pide checkPreviews ', payloadMd5Data)

  requestPostSail( process.env.REACT_APP_URL_SERVICES + 'slides/checkPreviews', payloadMd5Data, this.callbackCheckPreviews.bind(this) );

}

fscg.sortFiles = function( items ) {
	if(items[0] == '.DS_Store')
		items.splice(0,1);

	if(isWin) {
		items.sort(function(a, b) {
			return fs.statSync(previewsPath + "/" + a).mtime.getTime() -
                      fs.statSync(previewsPath + "/" + b).mtime.getTime();
       	});
	}
	else{
		items.sort(function(a, b) {
      return (Number(a.match(/(\d+)/g)[0]) - Number((b.match(/(\d+)/g)[0])));
    });
	}

}

fscg.getDimensionSlide = function( url ){
	var sizeOf = window.require('image-size');
	var dimensions = sizeOf(url);
	widhtImage = dimensions.width;
	heightImage = dimensions.height;
}

fscg.getPayloadExport = function( useStoredName = false ){
	let payloadMd5Data = {};

	payloadMd5Data.data = [];
	payloadMd5Data.pptName = ( useStoredName  ? platformHandler.getPPTName() : this.getPPTName());
	payloadMd5Data.userId = platformHandler.getUser();
	payloadMd5Data.firstData = false;

	return payloadMd5Data;
}

fscg.setMD5Items = function( items, payloadMd5Data, allPreviews ){
	for (var i=0; i<items.length; i++) {
		var md5FileHash = md5File.sync(previewsPath + "/" + items[i]);

    	var previewInfo = {
			path: previewsPath + "/" + items[i],
			id: i+1,
			fileName: items[i],
			md5: md5FileHash,
			sent: false
		}

    	allPreviewsExport.push(previewInfo);

    	//Se coloca la url vacia porque igual el sails no sobreescribe directamente sino que
    	//procesa pero si es la primera vez si guarda el vacio
    	payloadMd5Data.data.push({	idSlide:i+1,
    						md5:md5FileHash,
    						note:platformHandler.slidesNotes[i],
    						url:""
    						});

    }
}

fscg.sendNextPreview = function() {
	if(currentPreviewToSendExport<allSlidesToRefreshExport.length-1) {
		currentPreviewToSendExport++;
		console.log('siguiente ' + currentPreviewToSendExport, allSlidesToRefreshExport);
		this.sendPreview();
	}
	else {

		var payload = {
			pptName:platformHandler.getPPTName(),
			userId: platformHandler.getUser(),
		};
		requestPostSail( process.env.REACT_APP_URL_SERVICES + 'slides/setCompleted', payload, (data) => { 
			isUploadingImages = false;
			if ( data.success ){
				platformHandler.setStateInitPresentation(2,1);
			} 
			else{
				this.cbStateUpload( { error:true} ,isWin);
			}
		});
		
	}
}

fscg.sendPreview = function() {
	//console.log(allSlidesToRefresh);
	//console.log('Corresponde a ' + JSON.stringify(allPreviews[allSlidesToRefresh[currentPreviewToSend]-1]));
	//console.log('Actualizar a slide con id ' + allPreviews[allSlidesToRefresh[currentPreviewToSend]-1].id + ' nombre: ' + allPreviews[allSlidesToRefresh[currentPreviewToSend]-1].path);

	//Si ya se envio la informacion de ese slide se ignora ya que por concurrencia se debe hacer,
	//es decir, ya se envio pero no se ha recibido respuesta aun.
	if(allPreviewsExport[allSlidesToRefreshExport[currentPreviewToSendExport]-1].sent){
		( platformHandler.isAuditoriumMode() && this.startedFromAuditorium) ? this.sendNextPreviewAuditorium() : this.sendNextPreview();
		return;
	}

	var scope = this;
	allPreviewsExport[allSlidesToRefreshExport[currentPreviewToSendExport]-1].sent = true;

	// read binary data
	var bitmap = fs.readFileSync(allPreviewsExport[allSlidesToRefreshExport[currentPreviewToSendExport]-1].path);
	var newFile = new Blob([bitmap]);
	platformHandler.getFirebaseConnector().uploadImage(platformHandler.getUser(),platformHandler.getPPTName(),allPreviewsExport[allSlidesToRefreshExport[currentPreviewToSendExport]-1].id,newFile
		, function(userId,pptName,slideIndex,downloadURL) {

			var payloadUrl = {
				pptName,
				userId,
				slideIndex,
				data: downloadURL,
				md5: allPreviewsExport[allSlidesToRefreshExport[currentPreviewToSendExport]-1].md5,
				last: !(currentPreviewToSendExport<allSlidesToRefreshExport.length-1),
			};

			console.trace('send image' + payloadUrl)

			requestPostSail( process.env.REACT_APP_URL_SERVICES + 'slides/uploadSlideUrl', payloadUrl, function( data ){
				if ( platformHandler.isAuditoriumMode() && scope.startedFromAuditorium){
					console.log('uploaded', data.slideIndex)
					platformHandler.modifySlideData(data.slideIndex,data.url);
				}
				else{
					platformHandler.setStateInitPresentation(1, data.slideIndex);
				}				
				
				( platformHandler.isAuditoriumMode() && scope.startedFromAuditorium) ? scope.sendNextPreviewAuditorium() : scope.sendNextPreview();
			});
		}
	);
}

fscg.callbackCheckPreviews = function( data ){
  console.log('Llega un export' + JSON.stringify(data))

  if( data.success ){
    //La respuesta contiene los slides que se deben cambiar unicamente
    allSlidesToRefreshExport = allSlidesToRefreshExport.concat(data.resp);
    allSlidesDataExport = data.allSlidesData;
    platformHandler.setSlidesData(data.allSlidesData);
    platformHandler.cloudPresentationID = data.idCloud;

    this.sendNextPreview();
  }
}

fscg.savePreview = function( previewData, index ){
  var bitmap = new Buffer( previewData, 'base64');
	
 if( !fs.existsSync(previewsPath + "Flipwit/")){
    fs.mkdirSync( previewsPath + "Flipwit/");
  }

  fs.writeFileSync( previewsPath + "Flipwit/" + index + '.jpg', bitmap);
  console.log('generated')
}

fscg.pdfToImagesFinished = function(  ){
  fs.unlinkSync( previewsPath + 'FlipwitPDF.pdf');

  previewsPath = previewsPath + "Flipwit/";

  if( !fs.existsSync(previewsPath )){
    fs.mkdirSync( previewsPath );
  }

  platformHandler.setStateInitPresentation(1, 1);
  fs.readdir(previewsPath, this.readDirUploadCB.bind(this));
}

fscg.ppClosed = function(  ){
	this.hideTogleaWindow();
	this.pptsOpen([]);
}

fscg.closeAuditoriumSession = function(  ){
	platformHandler.sendQuestionsToExhibitor();
    platformHandler.closeCurrentSession();
}

fscg.checkIfClosePresentation = function(  ){
	if ( platformHandler.inSlideShowMode ){
		console.log('amountConnections', platformHandler.amountConnections)
		if ( platformHandler.amountConnections <= 1 ){//solo existe este electron
			this.closeAuditoriumSession();
	        platformHandler.openScene("SelectPresentation");
		}
	}
}



// WEBPACK FOOTER //
// ./src/containers/platforms/electron/js/powerpoint/FlipwitSlideConnectorGeneral.js